<template>
  <div class="bidOrder">
    <div class="title">设置路桥集团招标委员会联审确认单信息</div>
    <el-form
      ref="ruleForm"
      :model="formData"
      label-width="140px"
      :inline="true"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="标题" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="日期">
            <el-date-picker
              v-model="formData.approveTime"
              type="date"
              placeholder="请选择日期"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目名称">
            <el-input v-model="formData.projectName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提报单位/部门">
            <el-input v-model="formData.commitDeptName" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="采购计划事项">
            <el-input v-model="formData.bidPlanItem" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="采购计划编号" prop="controlPriceId">
            <el-input v-model="formData.bidPlanCode" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目类别">
            <el-input v-model="formData.projectType" readonly></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="采购金额">
            <el-input v-model="formData.estimatePrice" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
     
      <el-row>
        <el-col :span="12">
          <el-form-item label="采购方式：">
            <el-input v-model="formData.bidPlanMethodValue" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否已取得决策依据">
            <el-input
              v-model="formData.decisionBaseDisplayName"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联签单类别">
            <el-select
              v-model="formData.signatureType"
              default-first-option
              placeholder="请选择"
              disabled
              style="width:100%"
            >
              <el-option label="招前联签单" value="before"></el-option>
              <el-option label="招后联签单" value="after"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="提报单位负责人">
            <el-input
              v-model="formData.commitResponseUserName"
              placeholder="请选择提报单位负责人"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="经办人">
            <el-input
              v-model="formData.handlingUserName"
              placeholder="请选择经办人"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="项目情况" prop="approveComment">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入内容"
              v-model="formData.projectState"
              style="width: 100%"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title">审批人及打印设置</div>

      <template v-for="(item, index) in formData.approveInfoList">
        <el-row :key="item.id" class="approveItem">
          <!-- <el-col :span="4">
            <el-form-item
              v-if="index == 0"
              label="参会部门及其负责人"
              prop="serialNumber"
            >
            </el-form-item>
            <el-form-item v-else label="" prop="serialNumber"> </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item
              :label="`审批人${index + 1}`"
              label-width="130px"
              prop="serialNumber"
            >
              <el-input v-model="item.approveUserName" readonly=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" style="margin-left: 10px">
            <el-input v-model="item.jobName"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="checkboxWrap">
              <el-checkbox v-model="item.isPrint" style="width: 40px" label="1"
                >打印
              </el-checkbox>
            </div>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="item.opinionKey"
              filterable
              default-first-option
              placeholder="请选择"
              @change="changeType(index)"
            >
              <el-option
                v-for="em in typeOptions"
                :key="em.label"
                :label="em.value"
                :value="em.label"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
      </template>
    </el-form>
    <div class="bottomBtn">
      <el-button type="primary" @click="print">打印预览</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
    <filePrint
      :visible.sync="printVisible"
      :printData="formData"
      v-if="printVisible"
    >
    </filePrint>
  </div>
</template>

<script>
import {
  getBidOrderdetail, //获取一条采购计划信息
  updateorderPricePrint,
} from "@/services/bidServices";
import { getsysDictDetailApi , getsignUrlApi} from "@/services/sysSettingService";
import {
  queryRealApproveProcessSign, //获取打印页面带签名审批详情
} from "@/services/approveServices";
import filePrint from "./orderPrint";

export default {
  name: "bidOrder",
  props: {
    itemId: {
      type: Number,
    },
    approveType: {
      type: String,
    },
  },
  components: {
    filePrint,
    // DeptSelectComponent,
    // PrintDeptSelectComponent,
  },
  data() {
    return {
      formData: {
        title: "路桥集团招标委员会联审确认单",
        approveTime: new Date(),
        typeOptions:[],
      },
      typeOptions:[],
      printVisible: false,
    };
  },
  watch: {
    itemId: {
      handler: function (newVal) {
        if (newVal) {
          this.getDetail(this.itemId);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getOptionType();
  },
  methods: {
    //获取一条会议提报单信息
    getDetail(id) {
      getBidOrderdetail({ bidSignatureId: id })
        .then((res) => {
          if (res.code == 10000000) {
            const data = res.data || {};
            data.title = data.title ?? "路桥集团招标委员会联审确认单";
            // data.approveTime = data.approveTime ?? new Date();

            if (!res.data.approveInfoList) {
              queryRealApproveProcessSign({
                itemId: id,
                approveClass: "BID_JOIN_SIGNATURE",
              }).then((res1) => {
                if (res1.code == 10000000) {
                  let approveInfoList = res1.data || [];
                  if (approveInfoList.length > 0) {
                    data.approveTime = data.approveTime ? new Date(data.approveTime) : new Date(data.approvePassTime||approveInfoList[approveInfoList.length-1].updateTime);
                    approveInfoList = approveInfoList.map((item) => {
                      item.isPrint = true;
                      item.opinionKey = "";
                      item.opinionValue = "";
                      return item;
                    });
                    this.formData = {
                      ...data,
                      approveInfoList,
                    };
                    this.formatDate.typeOptions=this.typeOptions;
                    // this.formData.approveInfoList=[]
                    // this.formData.approveInfoList=[...approveInfoList]
                  }
                }
              });
            } else {
              this.formData = {
                ...data,
                approveInfoList: data.approveInfoList,
                typeOptions:this.typeOptions,
              };
              // this.formatDate.typeOptions=this.typeOptions;
              // this.formData.approveInfoList = data?.approveInfoList || [];
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    //获取项目部下拉列表数据
    getOptionType() {
      let reqParam = {
        key: "bidSignaturePrint",
      };
      getsysDictDetailApi(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.typeOptions = res.data;
            this.formatDate.typeOptions=this.typeOptions;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    submit() {
      let newOj = {
        approveTime: this.formData.approveTime,
        bidSignatureId: this.itemId,
        title: this.formData.title,
      };
      newOj.approveInfoList = this.formData.approveInfoList;
      updateorderPricePrint({
        ...newOj,
      })
        .then((res) => {
          if (res.code == 10000000) {
            this.$alert("保存成功", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert(res.msg, "确定");
          }
        })
        .catch((err) => {
          this.$message.error("网络请求失败");
        });
    },
     //获取审批人签名
     getsignUrlFun() {
      let reqParam = {
        signUserIdSet: this.formData.approveInfoList.map(item=>item.approveUserId).join(','),
      };
      getsignUrlApi(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            let urls=res.data
            this.formData.approveInfoList.forEach(em => {
              let s=urls.find(item=>item.userId==em.approveUserId) 
              if(s&&s.signUrl)             
              em.approveUserNameSignUrl=s.signUrl
              return em
            });
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    async print() {
      await this.getsignUrlFun()
      this.formData.typeOptions=[]
      this.formData.typeOptions=this.typeOptions;
      this.printVisible = true;
      this.$emit("handlePrint", {
        formData: this.formData,
        approveList: this.approveList,
      });
    },

    //切换审批人分组
    changeType(i) {
      let index = this.typeOptions.findIndex(
        (item) => item.label === this.formData.approveInfoList[i].opinionKey
      );
      if (index !== -1) {
        // this.ruleForm.typeKey = this.typeOption[index].label;
        this.formData.approveInfoList[i].opinionValue =
          this.typeOptions[index].value;
      }
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      return `${year}年${month}月${day}日`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.bidOrder {
  margin-bottom: 30px;
  .title {
    margin: 10px 0;
    font-weight: bold;
  }

  .marginLeft8 {
    margin-top: 18px;
    margin-left: 4px;
  }

  .checkboxWrap {
    width: 110px - 12px;
    text-align: left;
    margin-left: 10px;
  }

  .bottomBtn {
    z-index: 100;
    left: 660px;
    position: fixed;
    bottom: 20px;
    height: 40px;
    line-height: 40px;
  }
}

/deep/ .el-form-item__content {
  width: 100%;
  .el-input {
    width: 100%;
  }
}
</style>
